import { Link } from "react-router-dom";
import FaqsComp from "../../components/FaqsComp";
import styles from "./Section8.module.css";

const questions = [
  "What services does Physicians Success Partners offer?",
  "What is Physicians Success Partners's mission?",
  "How does Physicians Success Partners help reduce costs?",
];

const answers = [
  "The Physicians Success Partners provides detailed billing solutions, guaranteeing accurate pay for healthcare workers' efforts.",
  "The main goal of Physicians Success Partners is to provide high-standard RCM solutions. We focus on raising income, improving cash flow, and standing by your side for success.",
  "Physicians Success Partners offers a full billing solution at a low cost, eliminating the need to hire expensive billing experts or train staff.",
];

export default function Section8() {
  return (
    <section className={styles.section}>
      <div className={`container ${styles.shell}`}>
        <div className={styles.contentColumn}>
          <span className={styles.kicker}>FAQs</span>
          <h2>End-to-End Solutions for New Healthcare Practices</h2>
          <p>
            Focused on cost-effective startup solutions, our{" "}
            <strong>expert medical billing consulting</strong> and revenue cycle
            management (RCM) services help new healthcare practices reduce costs
            and maximize revenue from day one. We support every stage of your
            launch, from credentialing and system implementation to early
            operational workflows, ensuring a smooth and compliant start.
          </p>

          <Link to="/contact-us" className={styles.ctaLink}>
            Meet Us
          </Link>
        </div>

        <div className={styles.faqColumn}>
          <FaqsComp question={questions} answer={answers} />
        </div>
      </div>
    </section>
  );
}
